import { CustomDimensionsRepository } from '../types';
import {
  getGaCustomDimensions,
  getGaCustomParams,
  updateCustomParam,
  updateCustomParams,
} from './dimensions';

export const createCustomDimensionsRepository =
  (): CustomDimensionsRepository => {
    return {
      getAllParams: getGaCustomParams,
      getAll: getGaCustomDimensions,
      update: updateCustomParams,
      set: updateCustomParam,
    };
  };
